import { getConditionsMenuItems } from "@iscr/views/UIelems/v2/serviceAndConditionsMenu/conditionsMenuItems";
import { useMemo, useState } from 'react';
import menu_model from "../../../../models/menu_model";
import { TabComponent } from "../tabs/TabComponent";
import ConditionsMenu from "./ConditionsMenu";
import ServicesMenu from "./ServicesMenu";


/*
 TODO - make common conditions and footer order configurable in contentful
 https://instant.atlassian.net/browse/INST-6323
*/
export default function ServiceAndConditionsMenu({ onMenuChange, showMenu, wl_link, initialView }) {
  const [activeTab, setActiveTab] = useState(initialView === 'Conditions' ? 2 : 1);
  const conditions = useMemo(() => getConditionsMenuItems({ wl_link}), [wl_link])

  const tabs = [
    { id: 1, label: "Services" },
    { id: 2, label: "Conditions" },
  ];

  const services = menu_model.get_servicesmenu()

  return (
    <section className="bg-white pt-6 pb-[60px] px-6 lg:py-9 lg:px-16">
      <TabComponent tabs={tabs} onTabChange={setActiveTab} active={activeTab} />

      {activeTab === 1 && <ServicesMenu onMenuChange={onMenuChange} services={services} />}
      {activeTab === 2 && <ConditionsMenu onMenuChange={onMenuChange} showMenu={showMenu} conditions={conditions} />}
    </section>
  );
}
